import {
	type Company,
	type CompanyJson,
	getValidCompanyJson,
	mapCompany,
} from "./Company";

export interface TokenAndCompaniesJson {
	token: string;
	companies: CompanyJson[];
}

interface TokenAndCompanies {
	token: string;
	companies: Company[];
}

export const mapTokenAndCompanies = (
	json: TokenAndCompaniesJson,
): TokenAndCompanies => {
	if (!json.token.trim()) {
		throw new Error("token cannot be empty");
	}

	const companies = json.companies.map(mapCompany);

	if (companies.length === 0) {
		throw new Error("company array can not be empty");
	}

	return {
		token: json.token,
		companies,
	};
};

export const getValidTokenAndCompanyJson = (): TokenAndCompaniesJson => ({
	token:
		"eyJraWQiOiIxNEdCdWtFWENiZlpJZ1ZXc0pubE14STUrVXlacXgxNU11aDFNTjdxQnFrPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiJiZWIxMmVmMi04ODVlLTRlNjQtOTBhYy0xOWM2NWI4Zjk3YjMiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuZXUtd2VzdC0xLmFtYXpvbmF3cy5jb21cL2V1LXdlc3QtMV9GNUR5SlVLaUoiLCJjbGllbnRfaWQiOiJkMXNpb3FjNDg4c29yMzljaHZnbTA2YmpwIiwib3JpZ2luX2p0aSI6IjQ0OThkNTYzLTI1ZTEtNDYxNi05ZGNlLTZmYWZkMTMxZThjMyIsImV2ZW50X2lkIjoiY2Y5NjIxNmMtOTk0Yi00MDhlLWE2NjYtMGI5ZWE0ZmE2MTU4IiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTY5OTgwOTY3MywiZXhwIjoxNjk5ODEzMjczLCJpYXQiOjE2OTk4MDk2NzMsImp0aSI6IjNiMzM2MGQzLWQ0NGQtNDkxNi05YmJjLTlmZmNiM2IzMjcwMyIsInVzZXJuYW1lIjoiYmViMTJlZjItODg1ZS00ZTY0LTkwYWMtMTljNjViOGY5N2IzIn0.HGvcNiRoyryOghYAlt-VX-dUqR7GuoqnjrALVzVj6sQcXZO5J1X_bG5c69baQgPnmI4ihuRZopVYFLPDiNIGoV6wyr5M23GqMEegVzlTM43izU_KzjTLuHC8zuU4k-30YHPLoKmzJxoIL-9et3EvTl8paWFjliZ4Pfetavzsa5HjT2Yl7b2AEKTU946-u62vywl3aAn9KKh0XR-G9bW_bsnMfWh0REPB7LLT41j7aaYUovBMR7jNXt9H1d-dbtbwJO9q53Eq0FlwfKPDUj-fDXkL9th60gNuT90brF7hDo80zF1cSLoH3G-flANjpg327kBs59D3-bhClVwWunMD-g",
	companies: [getValidCompanyJson()],
});
